import React, { useEffect } from 'react';
import { Image, Link, mergeStyleSets } from '@fluentui/react';
import BreadcrumbComponent from '../../components/breadcrumb/breadcrumb.component';
import { Buffer } from "buffer";

import useAuthStatus from '../../hooks/auth/AuthHook';

import welcomeImage from '../../assets/bienvenida.png';
import { useNavigate } from 'react-router-dom';

const classes = mergeStyleSets({
    number: {
        fontSize: 64,
        lineHeight: 56,
        height: 96,
        width: 96,
        minWidth: 96,
        borderRadius: 96,
        border: 'solid 5px var(--color-primario)',
        color: 'var(--color-primario)',
        display: 'block',
        textAlign: 'center',
        padding: 16,
    },
    image: {
        minHeight: 740,
    },
    numberLine: {
        minHeight: 135,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: '1 1 auto !important',
        paddingTop: 10,
        paddingBottom: 10,
    },
    numberLineHeader: {
        flex: '1 1 auto !important',
        minHeight: 100,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingTop: 10,
        paddingBottom: 10,
    },
    numberLineFooter: {
        flex: '1 1 auto !important',
        minHeight: 100,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingTop: 10,
        paddingBottom: 10,
    },
});

interface IWelcomePageProps {};

const WelcomePage = (props : IWelcomePageProps) => {
    const auth = useAuthStatus();
    const navigate = useNavigate();

    useEffect(() => {
        if (auth.user) {
            if (!auth.user.ModoBienvenida) {
                if (!auth.user.UsuarioAdmin) {
                    navigate('/main/ordenes-trabajo');
                }
                else {
                    navigate('/main/resumen-actividad');
                }
            }
        }
    }, [auth.user, navigate]);

    const download = (event: React.MouseEvent<HTMLElement | HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => {
        if (auth.user) {
            let base64 : string = Buffer.from(`${auth.user.IdUsuario}-${auth.user.CodigoCliente}-${auth.user.Token}-MyMov.msi`, 'utf8').toString('base64');
            window.open(`${(process.env.REACT_APP_API_URL || "")}Home/Descarga/${base64}`, '_blank');
        }
    };

    return (
        <div className='d-flex flex-column h-100 w-100'>
            <div className="row m-0">
                <div className='col-12'>
                    <BreadcrumbComponent items={["Inicio", "Bienvenida"]} />
                </div>
            </div>
            {
                auth.user ? (
                    <>
                        <div className="row m-0 flex-fill overflow-hidden">
                            <div className="col-12 h-100 overflow-auto d-flex flex-column">
                                <div className='row h-100'>
                                    <div className='col-auto h-100 d-none d-lg-block'>
                                        <Image 
                                            src={welcomeImage}
                                            alt=""
                                            height="100%"
                                            className={classes.image} />
                                    </div>
                                    <div className='col h-100'>
                                        <div className='row h-100 d-flex justify-content-between align-items-center'>
                                            <div className={classes.numberLineHeader}>
                                                <p className='m-0'>
                                                    <b>
                                                        Bienvenido a MyMov.
                                                    </b> Has concluído tu registro con éxito, ahora te indicamos los primeros pasos a realizar para comenzar a utilizar nuestra 
                                                    plataforma.
                                                </p>
                                            </div>
                                            <div className={classes.numberLine}>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <span className={classes.number}>
                                                        1
                                                    </span>
                                                    <p className="m-0 px-3">
                                                        <b>
                                                            Descarga e instala MyMov Desktop en tu PC.
                                                        </b> Podrás administrar y gestionar completamente tu espacio: crear usuarios, crear contactos y direcciones, crear tareas y 
                                                        asignarlas a rutas y mucho más. Aquí tienes el enlace de descarga de <Link onClick={download}>
                                                            MyMov Desktop para Windows
                                                        </Link>.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={classes.numberLine}>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <span className={classes.number}>
                                                        2
                                                    </span>
                                                    <p className="m-0 px-3">
                                                        <b>
                                                            Inicia sesión en MyMov Desktop.
                                                        </b> Utiliza las credenciales que nos has indicado durante el proceso de registro para acceder a MyMov Desktop y comienza a 
                                                        ahorrar tiempo y costes operativos.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={classes.numberLine}>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <span className={classes.number}>
                                                        3
                                                    </span>
                                                    <p className='m-0 px-3'>
                                                        <b>
                                                            Si has llegado a este paso, ya lo tienes.
                                                        </b> Ahora estás conectado a nuestra plataforma y podrás administrar y gestionar completamente tu espacio: crear usuarios, 
                                                        contactos, direcciones, tareas, rutas y asignarlas a tus usuarios...
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={classes.numberLine}>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <span className={classes.number}>
                                                        4
                                                    </span>
                                                    <p className='m-0 px-3'>
                                                        <b>
                                                            Invita a tus usuarios a unirse a tu espacio.
                                                        </b> Envía invitaciones a tus usuarios para que formen parte de tu equipo y así poder asignarles tareas y enviárselas a la 
                                                        APP de MyMov.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={classes.numberLineFooter}>
                                                <p className='m-0'>
                                                    Así de fácil, <b>
                                                        ya puedes comenzar a usar nuestra plataforma
                                                    </b>, pero no estarás solo durante el proceso. Ponemos  nuestro equipo a tu disposición para cualquier pregunta que quieras 
                                                    realizarnos, tan solo tienes que escribirnos un correo a <a href="mailto:ayuda@mymov.app">ayuda@mymov.app</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    null
                )
            }
        </div>
    );
};

export default WelcomePage;
